<template>
<div>
    <div v-if="showOutOfStockModal" class="modal-overlay" @click="closeOutOfStockModal">
        <div class="modal-content out-of-stock-modal" @click.stop>
            <div class="intro-modal-body">
                <div class="intro-modal-heading">
                    <strong>{{ currentMedicationType === 'mounjaro' ? 'Mounjaro' : 'Ozempic' }} is temporarily out of stock as we await our next shipment. You may choose an alternative medication now, or we'll notify you as soon as it becomes available.</strong>
                </div>
                <button class="modal-close-button" @click="closeOutOfStockModal">Close</button>
            </div>
        </div>
    </div>
    <div v-if="pageForm===1">
    <section class="section-12">
        <div class="div-block-2173"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" class="image-648"></div>
    </section>
    <section class="section_quiz" v-if="active_el!==6">
        <div class="quiz-wrap" :class="{'removePad' : active_el===1}">
            <div class="glpquiz_div">
                <div data-w-id="152494e0-8119-c24d-56ec-cbcb86819b09" class="quiz_herodiv" v-if="active_el === 1">
                    <div class="quiz_heroimgdiv hide">
                        <div class="glpquizheroheader">LIFE-CHANGING<br>WEIGHT LOSS MEDICATION</div>
                        <div class="text-block-1603">Get pre-approved for GLP medication with our 3-minute online assessment.</div>
                    </div>
                    <div class="quiz_heroviddiv">
                        <div data-poster-url="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-poster-00001.webp" data-video-urls="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.mp4,https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.webm" data-autoplay="true" data-loop="true" data-wf-ignore="true" class="background-video-10 w-background-video w-background-video-atom"><video id="92712d6a-272d-29db-a510-112844a8ae35-video" autoplay="true" loop="true" style="background-image:url('https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-poster-00001.jpg')" muted="true" playsinline="true" data-wf-ignore="true" data-object-fit="cover">
                                <source src="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.mp4" data-wf-ignore="true">
                                <source src="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.webm" data-wf-ignore="true">
                            </video>
                            <div class="vid-text-div">
                                <div class="glpquizheroheader">LIFE-CHANGING<br>WEIGHT LOSS MEDICATION</div>
                                <div class="text-block-1603">Get pre-approved for GLP medication with our 3-minute online assessment.</div>
                            </div>
                        </div>
                    </div>
                    <div class="glp-quiz-button-div">
                        <div class="rx-preview-div"><img src="@/assets/images/NS_Cream_NanoNAD_BlueTilt.webp" loading="lazy" alt=""></div>
                        <div class="rx-preview-div overlap"><img src="@/assets/images/NS_Vial_TirzTilt.webp" loading="lazy" alt=""></div>
                        <div class="rx-preview-div overlap"><img src="@/assets/images/NS_Vial_SemaTilt.webp" loading="lazy" alt=""></div>
                        <a href="#quizstep1" @click.prevent="handleGetStarted" class="link-block-105 w-inline-block">
                            <div class="text-block-1612">GET STARTED</div>
                            <div class="div-block-2175"><img src="@/assets/images/icon_arrownext.svg" loading="lazy" alt=""></div>
                        </a>
                    </div>
                </div>

                <!-- Step 2: Question 1 - Biggest Motivation -->
                <div id="quizstep1" class="quizquestiondiv" v-if="active_el === 2">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">4</div>
                        </div>
                    </div>
                    <div class="text-block-1604">What's Your Biggest Motivation?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'Lose weight or Treat Diabetes')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'Lose weight or Treat Diabetes'}">
                                <div>
                                    <div class="text-block-545">Lose weight or Treat Diabetes</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'Control Appetite')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'Control Appetite'}">
                                <div>
                                    <div class="text-block-545">Control Appetite</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'End Sugar Cravings')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'End Sugar Cravings'}">
                                <div>
                                    <div class="text-block-545">End Sugar Cravings</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'All of the Above')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'All of the Above'}">
                                <div>
                                    <div class="text-block-545">All of the Above</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>

                <!-- Step 3: Question 2 - Favorite Part of 100% Online -->
                <div id="quizstep2" class="quizquestiondiv" v-if="active_el === 3">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">4</div>
                        </div>
                    </div>
                    <div class="text-block-1604">What's Your Favorite Part of 100% Online?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'On-Demand Personalized Treatment')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'On-Demand Personalized Treatment'}">
                                <div>
                                    <div class="text-block-545">On-Demand Personalized Treatment</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'Buying From the Comfort of Home')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'Buying From the Comfort of Home'}">
                                <div>
                                    <div class="text-block-545">Buying From the Comfort of Home</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'Skipping the Long, Expensive Doctor\'s Office')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'Skipping the Long, Expensive Doctor\'s Office'}">
                                <div>
                                    <div class="text-block-545">Skipping the Long, Expensive Doctor's Office</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'All of the Above')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'All of the Above'}">
                                <div>
                                    <div class="text-block-545">All of the Above</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>

                <!-- Step 4: Question 3 - Most Important -->
                <div id="quizstep3" class="quizquestiondiv" v-if="active_el === 4">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">4</div>
                        </div>
                    </div>
                    <div class="text-block-1604">Let's Match You With the Best Medication - What's Most Important To You</div>
                    
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'Affordability (Lowest Price)')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'Affordability (Lowest Price)'}">
                                <div>
                                    <div class="text-block-545">Affordability (Lowest Price)</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'Potency (Strongest Dose)')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'Potency (Strongest Dose)'}">
                                <div>
                                    <div class="text-block-545">Potency (Strongest Dose)</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'Guided Plan (Personalized Long-Term Treatment)')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'Guided Plan (Personalized Long-Term Treatment)'}">
                                <div>
                                    <div class="text-block-545">Guided Plan (Personalized Long-Term Treatment)</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'All of the Above')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'All of the Above'}">
                                <div>
                                    <div class="text-block-545">All of the Above</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>

                <!-- Step 5: Question 4 - How Soon -->
                <div id="quizstep4" class="quizquestiondiv" v-if="active_el === 5">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">4</div>
                        </div>
                    </div>
                    <div class="text-block-1604">How soon do you want to start achieving your goals with GLP-1s?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleFinalSelection('ASAP - I\'m ready to start now')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'ASAP - I\'m ready to start now'}">
                                <div>
                                    <div class="text-block-545"><strong>ASAP</strong> - I'm ready to start now</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Soon - Not the right time just yet')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'Soon - Not the right time just yet'}">
                                <div>
                                    <div class="text-block-545"><strong>Soon</strong> - Not the right time just yet</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Not Sure - I\'m still deciding')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'Not Sure - I\'m still deciding'}">
                                <div>
                                    <div class="text-block-545"><strong>Not Sure</strong> - I'm still deciding</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Need More Info')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'Need More Info'}">
                                <div>
                                    <div class="text-block-545">Need More Info</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
                
                <div data-w-id="f1737dbf-9e11-0949-3790-41c4a681761e" class="disappearing-footer mobile-footer" v-if="active_el === 1">
                    <div class="text-block-1607">Newself © All rights reserved</div>
                    <div class="text-block-1605">
                        <a href="https://newself.com/terms-of-use" class="link-83" target="_blank">Terms of Service  </a>·  <a href="https://newself.com/privacy-policy" class="link-83" target="_blank">Privacy Policy  </a>·  <a target="_blank" href="https://newself.com/telehealth-consent" class="link-83">Telehealth Consent</a>
                    </div>
                    <div class="text-block-1606">Newself is not a laboratory or a medical provider. Results from RX Path may vary.Medication prescriptions are at the discretion of medical providers and may not be suitable for everyone.</div>
                </div>
            </div>
        </div>
    </section>
    <section id="quiz-footer" class="quiz-footer" v-if="active_el === 6">
        <div class="bottom-wrap">
            <div class="glp-quiz-footer-div">
                <div class="footer-hero">
                    <div class="fotter-text-side">
                        <div class="text-block-1608">Good News!<br/>We can help!</div>
                        <div class="text-block-1609">We have the meds that you need!</div>
                    </div>
                    <div class="div-block-2174"><img src="@/assets/images/NS_GLPgrp2.webp" loading="lazy" alt="" class="image-649"></div>
                </div>
                <div class="footer-bullets-div">
                    <div class="footer-bullet-div"><img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-650">
                        <div class="text-block-1610">All Dosages are the same price.</div>
                    </div>
                    <div class="footer-bullet-div"><img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-650">
                        <div class="text-block-1610">FDA 503A Licensed Pharmacies.</div>
                    </div>
                    <div class="footer-bullet-div"><img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-650">
                        <div class="text-block-1610">Doctor Prescribed. No Insurance Needed.</div>
                    </div>
                </div>
                <a href="#" @click.prevent="redirectToPrequalify" class="button-166 w-button">FINISH MY PRE-APPROVAL NOW</a>
                <div class="bottom-footer-div">
                    <div style="height:200px"></div>
                    <div class="text-block-1611">Newself © All rights reserved</div>
                    <div class="text-block-1605-copy">
                        <a href="https://newself.com/terms-of-use" class="bottom-links" target="_blank">Terms of Service  </a>·  <a href="https://newself.com/privacy-policy" class="bottom-links" target="_blank">Privacy Policy  </a>·  <a target="_blank" href="https://newself.com/telehealth-consent" class="bottom-links">Telehealth Consent</a>
                    </div>
                    <div class="bottom-disclosure">Newself is not a laboratory or a medical provider. Results from RX Path may vary. Medication prescriptions are at the discretion of medical providers and may not be suitable for everyone.</div>
                </div>
            </div>
        </div>
    </section>
    </div>
    <div v-if="pageForm===2">
        <div v-if="isLoading" class="loading-overlay2">
            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                    </circle>
                </svg>
            </div>
        </div>
        <section class="section-12">
            <div class="div-block-2173-copy">
                <div class="quiz-header-div">
                    <div class="header-div-top">
                        <a href="#" @click.prevent="goBack" v-if="active_el_ques > 1" class="w-inline-block">
                            <img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651">
                        </a>
                        <img src="@/assets/images/NewSelf_Logo.webp" loading="lazy"
                            sizes="(max-width: 1000px) 100vw, 1000px"
                            srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w"
                            alt="" class="image-648-copy">
                        <div class="text-block-1613">APPROVAL PROGRESS</div>
                    </div>
                    <div class="progress-wrap">
                        <div class="progress-bar-div" :style="{ width: progressPercentage + '%' }"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section_quiz">
            <div class="quiz-wrap" style="background-color: #fff;">
                <div class="glpquiz_div2">

                    <!-- Step 1: State -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 1">
                        <div class="quizquestionheader">What state do you reside in?</div>
                        <div class="form-subs">We need to match you to a licensed clinician in your state.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSubmit">
                                <select v-model="people.state" required class="select-field-7 form glp w-select"
                                    :class="{ 'field-error': fieldErrors.state }">
                                    <option value="">State...</option>
                                    <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}
                                    </option>
                                </select>
                                <input type="submit" class="form-button glp w-button" value="Next →">
                            </form>
                        </div>
                    </div>

                    <!-- Step 2: Name -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 2">
                        <div class="quizquestionheader">Who do I have the pleasure of talking to?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSubmit">
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input v-model="people.first_name" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.first_name }"
                                        placeholder="First Name" type="text" required>
                                </div>
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input v-model="people.last_name" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.last_name }"
                                        placeholder="Last Name" type="text" required>
                                </div>
                                <input type="submit" class="form-button glp w-button" value="Next →">
                            </form>
                        </div>
                    </div>

                    <!-- Step 3: Gender -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 3">
                        <div class="quizquestionheader">What was your gender at birth?</div>
                        <div class="form-subs">This will help our doctors recommend the proper medications and dosages.
                        </div>
                        <div class="felix-form-block w-form">
                            <form>
                                <a href="#" @click.prevent="handleGenderSelectionAndAdvance('Female')"
                                    class="link-block-30 w-inline-block"
                                    :class="{ 'selected': people.gender === 'Female' }">
                                    <div>
                                        <img loading="lazy"
                                            src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d8197d38318417c44d9c4_Female.svg"
                                            alt="" class="image-307">
                                        <div class="text-block-545">Female</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">→</div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="handleGenderSelectionAndAdvance('Male')"
                                    class="link-block-30 w-inline-block"
                                    :class="{ 'selected': people.gender === 'Male' }">
                                    <div>
                                        <img loading="lazy"
                                            src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d81974f75b229e7b38302_Male.svg"
                                            alt="" class="image-307">
                                        <div class="text-block-545">Male</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">→</div>
                                    </div>
                                </a>
                                <div v-if="formErrors.gender" class="error-message">{{ formErrors.gender }}</div>
                            </form>
                        </div>
                    </div>

                    <!-- Step 4: Email -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 4">
                        <div class="quizquestionheader">Please enter your email</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSubmit">
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input v-model="people.email" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.email, 'email-error-highlight': emailCheckError }"
                                        @blur="checkEmailOnBlur"
                                        placeholder="Your email" type="email" required>
                                    <div v-if="emailCheckError" class="email-check-error">{{ emailCheckError }}</div>
                                </div>
                                <button type="submit" class="form-button glp w-button" :disabled="isCheckingEmail">
                                    <span v-if="isCheckingEmail">Please wait...</span>
                                    <span v-else>Next →</span>
                                </button>
                            </form>
                        </div>
                    </div>

                    <!-- Step 5: Phone -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 5">
                        <div class="quizquestionheader">Please enter your mobile number</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSubmit">
                                <div class="form-group">
                                    <input v-model="formattedPhone" class="checkout-flow-input w-input" maxlength="16"
                                        :class="{ 'field-error': fieldErrors.phone }"
                                        placeholder="Primary phone (123) 456-7890" type="text"
                                        inputmode="numeric" autocomplete="off"
                                        @input="handlePhoneInput" 
                                        @keypress="enforceNumericOnly"
                                        @paste="sanitizePaste" required>
                                    <div v-if="fieldErrors.phone" class="phone-input-error">Please enter a valid US phone number</div>
                                    <div class="sms-consent-row" :class="{ 'sms-consent-shake': smsConsentShake, 'sms-consent-row-error': smsConsentError }">
                                        <input type="checkbox" id="checkbox-sms" name="checkbox-sms" class="sms-consent-checkbox" v-model="people.agree_to_phone" @change="smsConsentError = ''">
                                        <label for="checkbox-sms" class="sms-phone-disclaimer">By checking the box, you agree that NewSelf can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.newself.com/privacy-policy" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Privacy Policy</a> and <a href="https://newself.com/terms-of-use" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Terms</a>.</label>
                                    </div>
                                </div>
                                <div class="sms-actions">
                                    <div v-if="smsConsentError" class="sms-consent-error">{{ smsConsentError }}</div>
                                    <input type="submit" class="form-button glp w-button" value="Next →">
                                </div>
                            </form>
                        </div>
                    </div>

                    <!-- Step 6: Date of Birth -->
                    <div class="question-div-2" v-if="active_el_ques === 6">
                        <div class="quizquestionheader">What is your date of birth?</div>
                        <div class="form-subs">Based on your date of birth our doctors can prescribe the proper
                            prescription.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateDOB">
                                <div class="dob-fields-style3">
                                    <select v-model="people.dob.mm" required class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.dob_mm }"
                                        @change="onMonthSelected">
                                        <option value="">Month</option>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                    <input ref="dobDay" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.dob_dd }" maxlength="2" pattern="[0-9]*" inputmode="numeric"
                                        v-model="people.dob.dd" placeholder="Day" type="text" required
                                        @input="onDayInput"
                                        @keypress="enforceNumericOnly"
                                        @paste="sanitizePaste">
                                    <input ref="dobYear" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.dob_yyyy }" maxlength="4" pattern="[0-9]*" inputmode="numeric"
                                        v-model="people.dob.yyyy" placeholder="Year" type="text" required
                                        @keypress="enforceNumericOnly"
                                        @paste="sanitizePaste">
                                </div>
                                <div v-if="isError" class="error-message">
                                    Please enter a valid date of birth. You must be at least 18 years old.
                                </div>
                                <input type="submit" class="form-button glp w-button" value="Next →">
                            </form>
                        </div>
                    </div>

                    <!-- Step 7: Height and Weight -->
                    <div class="question-div-2" v-if="active_el_ques === 7">
                        <div class="quizquestionheader">What is your height and weight?</div>
                        <div class="form-subs">We'll use this to determine your Body mass Index (BMI) for diagnosis.
                            remember, BMI is a measure of size - not health</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSubmit">
                                <div class="div-block-1478 mobile-entry form _2 height top">
                                    <input v-model="people.height.foot" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.height }"
                                        placeholder="Feet" type="text" pattern="[0-9]*" inputmode="numeric" 
                                        id="height-feet"
                                        maxlength="1"
                                        @input="onFeetInput"
                                        @keypress="enforceNumericOnly"
                                        @paste="sanitizePaste"
                                        required>
                                    <input v-model="people.height.inches" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.height }"
                                        placeholder="Inches" type="text" pattern="[0-9]*" inputmode="numeric" 
                                        id="height-inches"
                                        maxlength="2"
                                        @input="onInchesInput"
                                        @keypress="enforceNumericOnly"
                                        @paste="sanitizePaste"
                                        required>
                                </div>
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input v-model="people.weight" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.weight }"
                                        placeholder="Weight in pounds" type="text" pattern="[0-9]*" inputmode="numeric"
                                        id="weight-pounds"
                                        maxlength="3"
                                        @input="onWeightInput"
                                        @keypress="enforceNumericOnly"
                                        @paste="sanitizePaste"
                                        required>
                                </div>
                                <input type="submit" class="form-button glp w-button" value="Next →">
                            </form>
                        </div>
                    </div>

                    <!-- Step 8: Desired Weight -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 8">
                        <div class="quizquestionheader">What is your desired weight?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSubmit">
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input v-model="people.desired_weight" class="quiz-text-field w-input"
                                        :class="{ 'field-error': fieldErrors.desired_weight }"
                                        placeholder="What is your goal weight in pounds?" type="text" pattern="[0-9]*" inputmode="numeric"
                                        maxlength="3"
                                        @input="onDesiredWeightInput"
                                        @keypress="enforceNumericOnly"
                                        @paste="sanitizePaste"
                                        required>
                                </div>
                                <input type="submit" class="form-button glp w-button" value="Next →">
                            </form>
                        </div>
                    </div>

                    <!-- Step 9: Currently Taking GLP Medications -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 9">
                        <div class="quizquestionheader">Do you currently take any GLP Weight Loss Medications?</div>
                        <div class="felix-form-block w-form">
                            <form>
                                <div class="div-block-1487">
                                    <a href="#" @click.prevent="handleGLPMedicationSelection('Yes')"
                                        class="button-68 w-button"
                                        :class="{ 'selected': people.currently_taking_glp === 'Yes' }">YES</a>
                                    <a href="#" @click.prevent="handleGLPMedicationSelection('No')"
                                        class="button-68 w-button"
                                        :class="{ 'selected': people.currently_taking_glp === 'No' }">NO</a>
                                </div>
                                <div v-if="formErrors.currently_taking_glp" class="error-message">{{
                                    formErrors.currently_taking_glp }}</div>
                            </form>
                        </div>
                    </div>

                    <!-- Step 10: What Medication -->
                    <div class="quizquestiondiv2" v-if="active_el_ques === 10">
                        <div class="quizquestionheader">What medication do you currently take?</div>
                        <div class="felix-form-block w-form">
                            <form>
                                <a href="#" @click.prevent="handleMedicationSelectionAndAdvance('Ozempic / Wegovy')"
                                    class="link-block-30 w-inline-block"
                                    :class="{ 'selected': people.current_medication === 'Ozempic / Wegovy' }">
                                    <div>
                                        <div class="text-block-545">Ozempic / Wegovy</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">→</div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="handleMedicationSelectionAndAdvance('Mounjaro / Zepbound')"
                                    class="link-block-30 w-inline-block"
                                    :class="{ 'selected': people.current_medication === 'Mounjaro / Zepbound' }">
                                    <div>
                                        <div class="text-block-545">Mounjaro / Zepbound</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">→</div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="handleMedicationSelectionAndAdvance('Semaglutide Compound')"
                                    class="link-block-30 w-inline-block"
                                    :class="{ 'selected': people.current_medication === 'Semaglutide Compound' }">
                                    <div>
                                        <div class="text-block-545">Semaglutide Compound</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">→</div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="handleMedicationSelectionAndAdvance('Tirzepatide Compound')"
                                    class="link-block-30 w-inline-block"
                                    :class="{ 'selected': people.current_medication === 'Tirzepatide Compound' }">
                                    <div>
                                        <div class="text-block-545">Tirzepatide Compound</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">→</div>
                                    </div>
                                </a>
                                <div v-if="formErrors.current_medication" class="error-message">{{
                                    formErrors.current_medication }}</div>
                            </form>
                        </div>
                    </div>

                    <!-- Step 11: Preferred Therapy -->

                    <!-- Step 12: Report Summary -->
                    <div class="step_chooserx_div" v-if="active_el_ques === 11">
                        <!-- Loading Overlay -->
                        <div v-if="isLoading" class="loading-overlay2">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                    <circle cx="50" cy="50" fill="none" stroke="#0c9ac4" stroke-width="10" r="35" stroke-dasharray="165 57">
                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                                    </circle>
                                </svg>
                            </div>
                        </div>

                        <div class="flow-step1-headers">
                            <div class="checkout-flow-headers">Choose your Treatment</div>
                            <div class="text-block-1686">Your healthcare practicioner will review your treatment with you before it&#x27;s finalized.</div>
                            <div class="div-block-2240 hide-flex">
                                <div class="text-block-1687">Not sure?</div>
                                <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                                    <div class="text-block-711">Talk with a Care Concierge</div>
                                </a>
                            </div>
                        </div>
                        <div class="flow_step-choiceflex-div">
                            <div class="flow-step1-choice">
                                <div class="flow-choice-img-div tirz"><img src="@/assets/images/TirzTilt.webp" loading="lazy" alt="" class="image-680">
                                    <div class="choice-pricetag">
                                        <div class="pricetag-div">
                                            <div class="text-block-1699">From ${{ lowestTirzPrice.dollars }}<span class="text-span-415"><sup class="superscript-7">{{ lowestTirzPrice.cents }}</sup></span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flow-step1-choice-info">
                                    <div class="choice-info-flex">
                                        <div class="info-flex-text">
                                            <div class="choice-productname">Trizepatide+</div>
                                            <div class="choice-productsub">COMPOUNDED W/ B6</div>
                                        </div>
                                        <button class="choice-button w-button" @click.prevent="handleTherapySelectionAndSubmit('tirzepatide')" :disabled="isLoading">
                                            
                                            <span >Select</span>
                                        </button>
                                    </div>
                                    <p class="paragraph-126 form">The most popular, GLP-2 weight loss program that works on two Glucagon receptor.</p>
                                </div>
                                <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                            </div>
                            <div class="flow-step1-choice">
                                <div class="flow-choice-img-div sema"><img src="@/assets/images/SemaTilt_1.webp" loading="lazy" alt="" class="image-680">
                                    <div class="choice-pricetag">
                                        <div class="pricetag-div">
                                            <div class="text-block-1700">From ${{ lowestSemaPrice.dollars }}<span class="text-span-415"><sup class="superscript-7">{{ lowestSemaPrice.cents }}</sup></span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flow-step1-choice-info">
                                    <div class="choice-info-flex">
                                        <div class="info-flex-text">
                                            <div class="choice-productname">Semaglutide+</div>
                                            <div class="choice-productsub">COMPOUNDED W/ B12</div>
                                        </div>
                                        <button class="choice-button w-button" @click.prevent="handleTherapySelectionAndSubmit('semaglutide')" :disabled="isLoading">
                                            
                                            <span>Select</span>
                                        </button>
                                    </div>
                                    <p class="paragraph-126 form">The original, GLP-1 weight loss program that works on one Glucagon receptor.</p>
                                </div>
                                <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                            </div>
                        </div>

                        <div class="flow_step-choiceflex-div">
                            <div class="flow-step1-choice">
                                <div class="flow-choice-img-div branded"><img src="@/assets/images/tilted-mounjaro.webp" loading="lazy" alt="" class="image-680">
                                    <div class="choice-pricetag branded">
                                        <div class="pricetag-div">
                                            <div class="text-block-1699">$1,495<span class="text-span-415"><sup class="superscript-7">97</sup></span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flow-step1-choice-info">
                                    <div class="choice-info-flex">
                                        <div class="info-flex-text">
                                            <div class="choice-productname">Mounjaro™</div>
                                            <div class="choice-productsub">Developed by Eli Lilly™</div>
                                        </div>
                                        <button class="choice-button w-button" @click.prevent="showOutOfStockForMedication('mounjaro')">Select</button>
                                    </div>
                                    <p class="paragraph-126 form">The most popular dual-action GLP-1 weight loss program with enhanced metabolic support.</p>
                                </div>
                                <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                            </div>
                            <div class="flow-step1-choice">
                                <div class="flow-choice-img-div branded"><img src="@/assets/images/tilted-ozempic.webp" loading="lazy" alt="" class="image-680">
                                    <div class="choice-pricetag branded">
                                        <div class="pricetag-div">
                                            <div class="text-block-1700">$1,899<span class="text-span-415"><sup class="superscript-7">97</sup></span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flow-step1-choice-info">
                                    <div class="choice-info-flex">
                                        <div class="info-flex-text">
                                            <div class="choice-productname">Ozempic™</div>
                                            <div class="choice-productsub">Developed by Novo Nordisk™</div>
                                        </div>
                                        <button class="choice-button w-button" @click.prevent="showOutOfStockForMedication('ozempic')">Select</button>
                                    </div>
                                    <p class="paragraph-126 form">A leading GLP-1 weight loss program that targets appetite regulation.</p>
                                </div>
                                <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer-section />
    </div>
    <!-- Paid User Modal -->
    <PaidUserModal
        :visible="showPaidUserModal"
        :email="people.email"
        :reason="paidUserReason"
        :role="paidUserRole"
        @close="showPaidUserModal = false" />
</div>
</template>

<script>
import FooterElement from '@/components/common/footerElement.vue'
import { cleanUsPhone, cleanUsPhoneInput, formatUsPhone, isValidUsPhone } from '@/utils/phone'
import state from "@/utils/state.json"
import { mapActions } from 'vuex'
import { getProductsById } from '@/utils/productData'
import { checkEmail, isValidEmailFormat } from '@/utils/checkEmail';
import PaidUserModal from '../common/PaidUserModal.vue';
export default {
    name: 'WeightLossStyleTwo',
    components: {
        'footer-section': FooterElement,
        PaidUserModal
    },
    data() {
        return {
            pricingConfig: JSON.parse(process.env.VUE_APP_PRICING || '{}'),
            pageForm: 1,
            active_el: 1,
            tempvalue: '',
            formErrors: {},
            fieldErrors: {},
            smsConsentError: '',
            smsConsentShake: false,
            isError: false,
            showPopup: true,
            originalBodyBgColor: '',
            showOutOfStockModal: false,
            emailCheckError: '',
            isCheckingEmail: false,
            showPaidUserModal: false,
            paidUserReason: 'paid_user',
            paidUserRole: '',
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            active_el_ques: 1,
            isSubmitting: false,
            isLoading: false,
            cartId: '',
            totalSteps: 12,
            currentMedicationType: '', 
            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agree_to_phone: false,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                ip_address: '',
                age: '',
                tracking_session_id: '',
                user_agent: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
                currently_taking_glp: '',
                current_medication: '',
                preferred_therapy: '',
            },
            quizAnswers: {
                question1: '',
                question2: '',
                question3: '',
                question4: ''
            },
        }
    },
    async mounted() {
        if (this.$route.query.sema) {
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
        this.loadFromLocalStorage();

        // Initialize tracking session
        try {
            const sessionId = await window.tracking.assertSession();
            this.people.tracking_session_id = sessionId;
        } catch(error) {
            if (window.trackingSessionId) {
                this.people.tracking_session_id = window.trackingSessionId;
            }
            console.log('Tracking session error:', error);
        }

        // Store original body background color
        this.originalBodyBgColor = document.body.style.backgroundColor || window.getComputedStyle(document.body).backgroundColor;

        // Set background color based on current pageForm
        this.updateBodyBackground();
    },
    beforeUnmount() {
        // Save progress when component is about to be unmounted
        this.saveToLocalStorage();

        // Restore original body background color
        document.body.style.backgroundColor = this.originalBodyBgColor;
    },
    computed: {

        progressPercentage() {
            return (this.active_el_ques / this.totalSteps) * 100;
        },
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        isValidPhone() {
            return isValidUsPhone(this.people.phone);
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },
        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        },
        lowestSemaPrice() {
            const total = this.pricingConfig.semaglutide.terms['12']
            const monthly = total / 12
            return { dollars: Math.floor(monthly), cents: Math.round((monthly % 1) * 100).toString().padStart(2, '0') }
        },
        lowestTirzPrice() {
            const total = this.pricingConfig.tirzepatide.terms['12']
            const monthly = total / 12
            return { dollars: Math.floor(monthly), cents: Math.round((monthly % 1) * 100).toString().padStart(2, '0') }
        },
        therapyPrice() {
            const med = this.people.preferred_therapy === 'Tirzepatide' ? 'tirzepatide' : 'semaglutide'
            return this.pricingConfig[med].terms['12'] / 12
        },
        totalOriginalPrice() {
            // Plan inclusions ($214) + Therapy price
            return 214 + this.therapyPrice;
        },
        totalSavings() {
            // Total original price minus current therapy price
            return this.totalOriginalPrice - this.therapyPrice;
        },
        formattedPhone: {
            get() {
                // Show an optional "1 " country code, e.g. "1 (555) 555-5555"
                return formatUsPhone(this.people.phone);
            },
            set(value) {
                // Keep an optional leading 1 country code; cap national part at 10
                this.people.phone = cleanUsPhoneInput(value);
            }
        }
    },
    methods: {

        ...mapActions([
            'setCartVisibility',
            'clearCart'
        ]),
        closeOutOfStockModal() {
            this.showOutOfStockModal = false;
            this.currentMedicationType = ''; // Reset selection
        },
        showOutOfStockForMedication(medication) {
            this.currentMedicationType = medication;
            this.showOutOfStockModal = true;
        },
        async checkEmailOnBlur() {
            this.emailCheckError = '';
            if (!this.people.email || !isValidEmailFormat(this.people.email)) {
                return;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                }
            } catch (e) {
                // Never block on error
            } finally {
                this.isCheckingEmail = false;
            }
        },
        async handleEmailCheck() {
            this.emailCheckError = '';
            if (!isValidEmailFormat(this.people.email)) {
                return true;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                    return false;
                }
                return true;
            } catch (e) {
                return true;
            } finally {
                this.isCheckingEmail = false;
            }
        },
        updateBodyBackground() {
            // Set background color based on pageForm
            if (this.pageForm === 1) {
                document.body.style.backgroundColor = '#f9f9f9';
            } else {
                document.body.style.backgroundColor = this.originalBodyBgColor;
            }
        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        goBack() {
            if (this.active_el_ques > 1) {
                // Special handling for step 11 (Choose your Treatment)
                if (this.active_el_ques === 11) {
                    // Check user's GLP medication status to determine correct back navigation
                    if (this.people.currently_taking_glp === 'No') {
                        // User selected "No", skip step 10 and return to step 9
                        this.active_el_ques = 9;
                    } else if (this.people.currently_taking_glp === 'Yes') {
                        // User selected "Yes", return to medication selection (step 10)
                        this.active_el_ques = 10;
                    } else {
                        // Safety fallback: if value is undefined/invalid, go to step 9
                        this.active_el_ques = 9;
                    }
                } else {
                    // Default behavior for all other steps: decrement by 1
                    this.active_el_ques--;
                }
            }
        },
        isValidDate(month, day, year) {
            const monthNum = parseInt(month);
            const dayNum = parseInt(day);
            const yearNum = parseInt(year);

            if (isNaN(monthNum) || isNaN(dayNum) || isNaN(yearNum)) {
                return false;
            }

            if (monthNum < 1 || monthNum > 12) return false;
            if (dayNum < 1 || dayNum > 31) return false;
            if (yearNum < 1924 || yearNum > new Date().getFullYear()) return false;

            const date = new Date(yearNum, monthNum - 1, dayNum);
            const today = new Date();

            if (date.getMonth() !== monthNum - 1 ||
                date.getDate() !== dayNum ||
                date.getFullYear() !== yearNum) {
                return false;
            }

            if (date > today) {
                return false;
            }

            return true;
        },
        calculateAge(month, day, year) {
            const today = new Date();
            const birthDate = new Date(year, month - 1, day);
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        },
        validateDOB() {
            this.fieldErrors = {};
            const { mm, dd, yyyy } = this.people.dob;

            if (!mm) {
                this.fieldErrors.dob_mm = true;
            }
            if (!dd) {
                this.fieldErrors.dob_dd = true;
            }
            if (!yyyy) {
                this.fieldErrors.dob_yyyy = true;
            }

            if (Object.keys(this.fieldErrors).length > 0) {
                this.isError = true;
                return;
            }

            if (!this.isValidDate(mm, dd, yyyy)) {
                this.fieldErrors.dob_mm = true;
                this.fieldErrors.dob_dd = true;
                this.fieldErrors.dob_yyyy = true;
                this.isError = true;
                return;
            }

            const age = this.calculateAge(parseInt(mm), parseInt(dd), parseInt(yyyy));
            if (age < 18) {
                this.fieldErrors.dob_mm = true;
                this.fieldErrors.dob_dd = true;
                this.fieldErrors.dob_yyyy = true;
                this.isError = true;
                return;
            }

            const paddedMonth = String(mm).padStart(2, '0');
            const paddedDay = String(dd).padStart(2, '0');
            this.people.dobMMDDYYYY = `${paddedMonth}/${paddedDay}/${yyyy}`;
            this.people.age = age;

            this.isError = false;
            try {
                if (window.tracking) {
                    window.tracking.event('dob_added', { funnel_step: 10, form: "pre_qualify" });
                }
            } catch(error) { console.log(error); }
            this.active_el_ques++;
        },
        onMonthSelected() {
            // Auto-focus to day input when month is selected
            this.$nextTick(() => {
                if (this.$refs.dobDay) {
                    this.$refs.dobDay.focus();
                }
            });
        },
        onDayInput(event) {
            // Sanitize input to only digits
            this.sanitizeNumericField(event, 2, 'dob.dd');
            // Auto-focus to year input when day has 2 digits
            if (this.people.dob.dd && this.people.dob.dd.toString().length === 2) {
                this.$nextTick(() => {
                    if (this.$refs.dobYear) {
                        this.$refs.dobYear.focus();
                    }
                });
            }
        },
        validateStep3() {
            this.fieldErrors = {};

            const foot = parseInt(this.people.height.foot);
            const inches = parseInt(this.people.height.inches);
            const weight = parseFloat(this.people.weight);

            if (isNaN(foot) || isNaN(inches) || foot < 4 || foot > 8 || inches < 0 || inches > 11) {
                this.fieldErrors.height = true;
                return false;
            }

            if (isNaN(weight) || weight < 80 || weight > 700) {
                this.fieldErrors.weight = true;
                return false;
            }

            this.people.heightInInches = (foot * 12) + inches;
            this.people.bmi = this.calculatedBMI;
            try {
                if (window.tracking) {
                    window.tracking.event('height', { funnel_step: 11, form: "pre_qualify" });
                    window.tracking.event('current_weight', { funnel_step: 11, form: "pre_qualify" });
                    window.tracking.event('bmi_confirmation', { funnel_step: 11, form: "pre_qualify" });
                }
            } catch(error) {
                console.log(error)
            }
            return true;
        },

        async validateStep4() {
            this.fieldErrors = {};

            const desiredWeight = parseFloat(this.people.desired_weight);
            const currentWeight = parseFloat(this.people.weight);

            if (isNaN(desiredWeight) || desiredWeight < 80 || desiredWeight > 700) {
                this.fieldErrors.desired_weight = true;
                return false;
            }

            if (desiredWeight >= currentWeight) {
                this.fieldErrors.desired_weight = true;
                return false;
            }

            // Fire goal_weight tracking before lead creation
            try {
                if (window.tracking) {
                    window.tracking.event('goal_weight', { funnel_step: 12, form: "pre_qualify" });
                }
            } catch(error) { console.log(error); }
            // Create lead after desired weight is entered
            await this.createLead();

            return true;
        },

        triggerSmsConsentShake() {
            this.smsConsentShake = false;
            this.$nextTick(() => {
                this.smsConsentShake = true;
                setTimeout(() => {
                    this.smsConsentShake = false;
                }, 700);
            });
        },
        async handleSubmit() {
            this.formErrors = {};
            this.smsConsentError = '';
            let isValid = true;

            // Validate based on current step
            this.fieldErrors = {};

            switch (this.active_el_ques) {
                case 1: // State
                    if (!this.people.state) {
                        this.fieldErrors.state = true;
                        isValid = false;
                    }
                    if (["LA", "MS"].includes(this.people.state)) {
                        this.$router.push({
                            name: 'leadDisqualified',
                            query: {
                                message: "Unfortunately, our GLP Medical Weight Loss program is not yet available in your state. However, we're excited to announce that it will be launching next month!"
                            }
                        });
                        return false;
                    }
                    if (isValid) {
                        try {
                            if (window.tracking) {
                                window.tracking.event('state', { funnel_step: 5, form: "pre_qualify" });
                            }
                        } catch(error) { console.log(error); }
                    }
                    break;
                case 2: // Name
                    if (!this.people.first_name || this.people.first_name.trim().length < 2) {
                        this.fieldErrors.first_name = true;
                        isValid = false;
                    }
                    if (!this.people.last_name || this.people.last_name.trim().length < 2) {
                        this.fieldErrors.last_name = true;
                        isValid = false;
                    }
                    if (isValid) {
                        try {
                            if (window.tracking) {
                                window.tracking.event('name_added', { funnel_step: 6, form: "pre_qualify" });
                            }
                        } catch(error) { console.log(error); }
                    }
                    break;
                case 3: // Gender
                    if (!this.people.gender) {
                        this.formErrors.gender = 'Please select your gender';
                        isValid = false;
                    }
                    break;
                case 4: // Email
                    if (!this.isValidEmail) {
                        this.fieldErrors.email = true;
                        isValid = false;
                    }
                    if (isValid) {
                        const emailCheckPassed = await this.handleEmailCheck();
                        if (!emailCheckPassed) {
                            return;
                        }
                        try {
                            if (window.tracking) {
                                window.tracking.event('email_complete', { funnel_step: 8, form: "pre_qualify" });
                            }
                        } catch(error) { console.log(error); }
                    }
                    break;
                case 5: // Phone
                    if (!this.isValidPhone) {
                        this.fieldErrors.phone = true;
                        isValid = false;
                    } else if (!this.people.agree_to_phone) {
                        this.smsConsentError = 'Please agree to receive SMS communications to continue';
                        this.triggerSmsConsentShake();
                        isValid = false;
                    } else {
                        try {
                            if (window.tracking) {
                                window.tracking.event('phone_added', { funnel_step: 9, form: "pre_qualify" });
                            }
                        } catch(error) { console.log(error); }
                    }
                    break;
                case 6: // DOB - handled by validateDOB function
                    return;
                case 7: // Height and Weight
                    isValid = this.validateStep3();
                    break;
                case 8: // Desired Weight
                    isValid = await this.validateStep4();
                    break;
            }

            if (!isValid) {
                return;
            }

            this.active_el_ques++;
        },

        async createLead() {
            try {
                this.isLoading = true;

                const feet = parseInt(this.people.height.foot) || 0;
                const inches = parseInt(this.people.height.inches) || 0;
                this.people.heightInInches = (feet * 12) + inches;

                this.people.bmi = this.calculatedBMI;

                this.people.user_agent = window.navigator.userAgent;
                try {
                    const sessionId = await window.tracking.assertSession();
                    this.people.tracking_session_id = sessionId;
                } catch(error) {
                    if (window.trackingSessionId) {
                        this.people.tracking_session_id = window.trackingSessionId;
                    }
                }

                const submissionData = {
                    ...this.people,
                    phone: cleanUsPhone(this.people.phone) // 10 national digits, drops leading 1 country code
                };

                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, submissionData, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                });

                if (response.data.status === 'success') {
                    try {
                        if (window.tracking) {
                            window.tracking.event('questionnaire_end', {
                                funnel_step: 13,
                                form: "pre_qualify"
                            });
                            window.tracking.event('partial', {
                                funnel_step: 14,
                                event_id: crypto.randomUUID(),
                                form: "pre_qualify"
                            });
                        }
                    } catch(error) {
                        console.log(error)
                    }

                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                }
            } catch (error) {
                console.error('Lead creation error:', error);
                this.formErrors.submission = 'There was an error saving your information. Please try again.';
            } finally {
                this.isLoading = false;
            }
        },

        async finalSubmit() {
            try {
                if (this.people.age < 18) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years."
                        }
                    });
                    return false;
                }

                // Lead was already created after step 8, so just show the report
                this.continueToNextPage();
            } catch (error) {
                console.error('Form submission error:', error);
                this.formErrors.submission = 'There was an error submitting your form. Please try again.';
            }
        },

        handleGLPMedicationSelection(value) {
            this.people.currently_taking_glp = value;
            this.formErrors = {};
            setTimeout(() => {
                if (value === 'Yes') {
                    this.active_el_ques = 10; // Go to medication selection
                } else {
                    this.active_el_ques = 11; // Skip medication, go to preferred therapy
                }
            }, 200);
        },

        handleMedicationSelectionAndAdvance(medication) {
            this.people.current_medication = medication;
            this.formErrors = {};
            setTimeout(() => {
                this.active_el_ques = 11; // Go to preferred therapy
            }, 200);
        },

        async handleTherapySelectionAndSubmit(therapy) {
            this.people.preferred_therapy = therapy;
            this.formErrors = {};
            try {
                if (window.tracking) {
                    window.tracking.event('treatment_selection', { funnel_step: 15, form: "pre_qualify" });
                }
            } catch(error) { console.log(error); }
            // Small delay for visual feedback
            await new Promise(resolve => setTimeout(resolve, 200));
            // Submit the form
            await this.finalSubmit();
        },

        handlePhoneInput(event) {
            // Cap to 10 digits, then force the displayed value so extra
            // keystrokes can't linger past the cap.
            this.people.phone = cleanUsPhoneInput(event.target.value);
            event.target.value = formatUsPhone(this.people.phone);
            if (this.fieldErrors.phone) {
                this.fieldErrors.phone = false;
            }
        },
        enforceNumericOnly(event) {
            // Prevent any non-numeric character from being typed
            const charCode = event.which ? event.which : event.keyCode;
            // Allow control keys: backspace(8), tab(9), enter(13), arrows(37-40), delete(46)
            if (charCode === 8 || charCode === 9 || charCode === 13 || 
                (charCode >= 37 && charCode <= 40) || charCode === 46) {
                return true;
            }
            // Allow only digits 0-9
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        sanitizePaste(event) {
            // Prevent paste and manually extract only digits
            event.preventDefault();
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            const digitsOnly = pastedText.replace(/\D/g, '');
            
            // Insert the sanitized value
            const target = event.target;
            const maxLength = target.maxLength;
            const finalValue = digitsOnly.slice(0, maxLength > 0 ? maxLength : digitsOnly.length);
            
            // Update the value and trigger input event
            target.value = finalValue;
            const inputEvent = new Event('input', { bubbles: true });
            target.dispatchEvent(inputEvent);
        },

        sanitizeNumericField(event, maxLength, field) {
            // Generic method to sanitize input to digits only
            if (event && event.target) {
                const digits = event.target.value.replace(/\D/g, '');
                const sanitized = digits.slice(0, maxLength);
                event.target.value = sanitized;
                // Update the model using lodash-style path or direct assignment
                if (field.includes('.')) {
                    const parts = field.split('.');
                    if (parts[0] === 'height') {
                        this.people.height[parts[1]] = sanitized;
                    } else if (parts[0] === 'dob') {
                        this.people.dob[parts[1]] = sanitized;
                    }
                } else {
                    this.people[field] = sanitized;
                }
            }
        },
        onFeetInput(event) {
            this.sanitizeNumericField(event, 1, 'height.foot');
            if (event.target.value.length === 1) {
                this.$nextTick(() => {
                    const inchesField = document.getElementById('height-inches');
                    if (inchesField) {
                        inchesField.focus();
                    }
                });
            }
        },
        onInchesInput(event) {
            this.validateNumericInput(event, 11);
            if (event.target.value.length === 2) {
                this.$nextTick(() => {
                    const weightField = document.getElementById('weight-pounds');
                    if (weightField) {
                        weightField.focus();
                    }
                });
            }
        },

        validateNumericInput(event, max) {
            let value = event.target.value.replace(/\D/g, '');
            if (max !== undefined && value !== '' && parseInt(value) > max) {
                value = String(max);
            }
            if (event.target.value !== value) {
                event.target.value = value;
                event.target.dispatchEvent(new Event('input', { bubbles: true }));
            }
        },
        onWeightInput(event) {
            this.sanitizeNumericField(event, 3, 'weight');
        },
        onDesiredWeightInput(event) {
            this.sanitizeNumericField(event, 3, 'desired_weight');
        },

        handleGenderSelectionAndAdvance(gender) {
            this.people.gender = gender;
            this.formErrors = {};
            try {
                if (window.tracking) {
                    window.tracking.event('sex_at_birth', { funnel_step: 7, form: "pre_qualify" });
                }
            } catch(error) { console.log(error); }
            setTimeout(() => {
                this.active_el_ques++;
            }, 200);
        },

        goBackToTherapySelection() {
            // Allow user to go back and change their therapy selection
            this.active_el_ques = 11;
        },

        saveToLocalStorage() {
            // Save current form progress to localStorage
            const formData = {
                active_el_ques: this.active_el_ques,
                people: this.people
            };
            localStorage.setItem('weightLossFormProgress', JSON.stringify(formData));
        },

        loadFromLocalStorage() {
            // Load saved form progress from localStorage
            try {
                const savedData = localStorage.getItem('weightLossFormProgress');
                if (savedData) {
                    const formData = JSON.parse(savedData);
                    // Restore the form data
                    this.active_el_ques = formData.active_el_ques || 1;
                    this.people = { ...this.people, ...formData.people };
                }
            } catch (error) {
                console.error('Error loading form data from localStorage:', error);
            }
        },

        clearLocalStorage() {
            // Clear saved form progress from localStorage
            localStorage.removeItem('weightLossFormProgress');
        },

        async continueToNextPage() {
            // Clear localStorage before proceeding
            this.clearLocalStorage();

            // Clear any existing cart
            await this.clearCart();

            // Get the product ID based on selected therapy
            let productId = this.people.preferred_therapy === 'tirzepatide' ? '675ac4cb6bf102c19ec3afe9' : '675ac4cb6bf102c19ec3afec';
            let product = await getProductsById(productId);
            let plan = product[0];

            // Construct cart item
            const cartItem = {
                id: plan.id,
                name: plan.name,
                category: plan.category.primary,
                price: plan.pricing.retail_price,
                retail_price: plan.pricing.retail_price,
                subheader: 'Compound Medication',
                sku: plan.sku,
                stripe_id: plan.stripe_id,
                quantity: 1,
                image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                is_addon: false,
            };
            try {
                if (window.tracking) {
                    // No event_value here: no payment term is chosen yet, so no cart
                    // total exists. The checkout reports the plan price once it does.
                    window.tracking.event('add_to_cart', {
                        funnel_step: 16,
                        currency: 'USD',
                        product_id: cartItem.id,
                        product_name: cartItem.name,
                        plan_id: cartItem.stripe_id,
                        quantity: 1,
                        form: "pre_qualify"
                    });
                }
            } catch(error) {
                console.log(error)
            }
            // Save cart to server
            this.saveCart(cartItem);
        },

        saveCart(cartItem) {
            this.isLoading = true;
            let postData = {
                ...cartItem,
                sema_offer: this.$store.getters.offerSema,
                tir_offer: this.$store.getters.offerTir,
                currentGLPMed: this.people.current_medication,
                currentDose: '', // We don't collect dose in this form
            };

            this.$axios.post(`${this.baseUrl}/api/save-cart`, postData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                if (response.data.status === 'success') {
                    this.cartId = response.data.id;
                    this.$store.dispatch('addToCart', cartItem);
                    this.setCartVisibility(false);

                    // Redirect to checkout with cart_id
                    this.$router.push({
                        name: 'checkoutWeightLoss',
                        params: {
                            cart_id: this.cartId
                        }
                    });

                    window.scrollTo(0, 0);
                    this.isLoading = false;
                } else {
                    alert("Unexpected response:", response.data);
                    this.isLoading = false;
                }
            })
            .catch(error => {
                alert("Error saving cart: " + error.message);
                this.isLoading = false;
            });
        },
        handleGetStarted() {
            try {
                if (window.tracking) {
                    window.tracking.event('questionnaire_start', { funnel_step: 1, form: "pre_qualify" });
                }
            } catch(error) {
                console.log(error)
            }
            this.active_el = 2;
        },
        handleOptionSelectionAndAdvance(questionKey, answer) {
            this.quizAnswers[questionKey] = answer;
            this.formErrors = {};
            
            // Fire tracking event for each question with proper event names per output.md
            try {
                if (window.tracking) {
                    const eventMap = {
                        'question1': { name: 'motivation', step: 2 },
                        'question2': { name: 'benefits', step: 3 },
                        'question3': { name: 'preferences', step: 4 }
                    };
                    
                    if (eventMap[questionKey]) {
                        window.tracking.event(eventMap[questionKey].name, {
                            funnel_step: eventMap[questionKey].step,
                            form: "pre_qualify"
                        });
                    }
                }
            } catch(error) {
                console.log(error);
            }
            
            // Automatically advance to next step after selection
            setTimeout(() => {
                this.active_el++;
            }, 200);
        },

        handleFinalSelection(answer) {
            this.quizAnswers.question4 = answer;
            this.formErrors = {};
            // Fire tracking event for Q4 (readiness/timeline question)
            try {
                if (window.tracking) {
                    window.tracking.event('readiness', { funnel_step: 4, form: "pre_qualify" });
                }
            } catch(error) {
                // tracking errors are non-fatal
            }
            // Show popup overlay after final question
            setTimeout(() => {
                this.active_el++;
            }, 200);
        },

        redirectToPrequalify() {
            this.pageForm=2;
        }
    },
    watch: {
        active_el() {
            window.scrollTo(0, 0)
        },

        calculatedBMI(newBMI) {
            this.people.bmi = newBMI;
        },
        active_el_ques() {
            // Wait for DOM update, then scroll to question
            this.$nextTick(() => {
                const questionDiv = document.querySelector('.quizquestiondiv2, .question-div-2');
                if (questionDiv) {
                    const header = document.querySelector('.section-12');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = 20; // Additional padding from header

                    const elementPosition = questionDiv.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                } else {
                    // Fallback to top if no question div found
                    window.scrollTo(0, 0);
                }
            });
            // Save progress whenever step changes
            this.saveToLocalStorage();
        },
        people: {
            handler() {
                // Save progress whenever people data changes
                this.saveToLocalStorage();
            },
            deep: true
        },
        pageForm() {
            // Update body background when switching between page 1 and page 2
            this.updateBodyBackground();
        }
    }
}
</script>

<style scoped>

/* Klarna badge */
.flow-step1-choice {
    position: relative;
}

.klarna-badge-flow {
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: 60px;
    height: auto;
    border-radius: 4px;
    z-index: 2;
}

.text-block-1604 {
    color: var(--black);
    text-align: center;
    margin-bottom: 60px;
    font-size: 30px;
    line-height: 39px;
}
.quizquestiondiv{
    padding-top: 0px !important;
}
.text-block-1608
 {
   font-size: 42px;
}
.no-discount-price{
    color: black;
    font-weight: bold;
}
@media (max-width: 479px) {
    .div-block-2173 {
        padding: 15px 10px 15px !important;
    }
    .removePad{
        padding-top: 0px !important;
    }
   .quiz_heroviddiv, .background-video-10 {
        height: calc(100vh - 350px);
    }
    .glpquiz_div {
        grid-row-gap: 0;
        padding-bottom: 0;
    }
    .quiz-wrap {
        padding-bottom: 0;
    }
    .text-block-1608{
        font-size: 32px !important;
    }
    .text-block-1610 {
        font-size: 18px !important;
    }
}

.progress-bar-div {
    height: 100%;
    background-color: var(--black);
    transition: width 0.3s ease;
}

.error-message {
    color: #ff4444;
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
}

.field-error {
    border-color: #ff4444 !important;
    border-width: 2px !important;
}

.dob-fields-style3 {
    display: grid;
    grid-template-columns: 2fr 1fr 1.2fr;
    gap: 10px;
    margin: 20px 0;
}

.dob-fields-style3 input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}

.dob-fields-style3 input[type="number"]::-webkit-inner-spin-button,
.dob-fields-style3 input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}

@media screen and (max-width: 767px) {
    .dob-fields-style3 {
        grid-template-columns: 1fr;
    }
}

/* Consistent form button sizing across all quiz steps */
.felix-form-block {
    max-width: 550px;
    margin-left: auto;
    margin-right: auto;
}

.felix-form-block .form-button {
    max-width: 550px;
    margin-left: auto;
    margin-right: auto;
    display: block;
}

/* Height/weight field layout */
.div-block-1478.mobile-entry.form._2.height.top {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 15px;
}

.div-block-1479.mobile-entry.form._2.weight {
    margin-bottom: 0;
}

.link-block-30.selected {
    background-color: #c9e8ff !important;
    opacity: .9;
}


/* Out of Stock Modal Styles */
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 99999;
}

.out-of-stock-modal {
    background-color: #ffffff;
    border-radius: 12px;
    max-width: 500px;
    width: 90%;
    margin: 0 !important;
    padding: 40px 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: none !important;
}

.out-of-stock-modal .intro-modal-body {
    padding: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.out-of-stock-modal .intro-modal-heading {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    margin: 0;
}

.modal-close-button {
    background-color: #e9ff86;
    color: #000;
    border: none;
    border-radius: 8px;
    padding: 12px 40px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.modal-close-button:hover {
    background-color: #d4e76f;
    transform: translateY(-2px);
}

/* Form Group - Same as /start route */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}

/* Field Hint - Same as /start route */

/* Let the email row wrap so the error drops below the input instead of beside it */
.div-block-1479 {
    flex-wrap: wrap;
}
.email-check-error {
    color: #dc3545;
    font-size: 13px;
    /* input is .w-input (10px margin-bottom); -7px lands the error ~3px under the box */
    margin-top: -7px;
    /* full-width forces it onto its own line under the input */
    flex: 0 0 100%;
    width: 100%;
    text-align: left;
}
.email-error-highlight {
    border-color: #dc3545 !important;
    background-color: #fff5f5 !important;
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.modal-content {
    background: white;
    padding: 30px;
    border-radius: 12px;
    max-width: 450px;
    width: 90%;
    text-align: center;
}
.modal-content h3 {
    margin: 0 0 12px;
    font-size: 20px;
}
.modal-content p {
    margin: 0 0 24px;
    color: #555;
    font-size: 15px;
    line-height: 1.5;
}
.modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}
.modal-btn {
    padding: 10px 24px;
    border-radius: 8px;
    font-size: 15px;
    cursor: pointer;
    border: none;
}
.modal-btn.cancel {
    background: #e9ecef;
    color: #333;
}
.modal-btn.login {
    background: #0c9ac4;
    color: white;
}

.sms-phone-disclaimer {
    font-size: 11px;
    line-height: 1.4;
    color: #6b7280;
    margin: -8px 0 16px;
}
.sms-phone-disclaimer-link {
    color: inherit;
    text-decoration: underline;
}
@media screen and (max-width: 768px) {
    .sms-phone-disclaimer {
        font-size: 10px;
    }
}

.form-button.glp + .enroll-disclaimer-div.form {
    margin-top: 8px;
}

.form-button.glp + .enroll-disclaimer-div.form .enroll-checkbox-field.form {
    margin-bottom: 0;
}

/* SMS consent checkbox (beside disclaimer, above Next button) */
.sms-actions {
    position: relative;
}
.sms-consent-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    /* gap to phone box = input 8px + form-group 6px + this; -12px lands ~2px under the box */
    margin: -12px 0 0;
    padding: 8px 10px;
    border: 1px solid transparent;
    border-radius: 9px;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}
.sms-consent-row .sms-phone-disclaimer {
    margin: 0;
    cursor: pointer;
    text-align: left;
}
.sms-consent-checkbox {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    margin: 2px 0 0;
    accent-color: #205089;
    cursor: pointer;
}
.sms-consent-row-error {
    border-color: #dc3545;
    background-color: rgba(220, 53, 69, 0.05);
}
.sms-consent-error {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    margin: 0 0 4px;
    color: #dc3545;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
}
.phone-input-error {
    color: #dc3545;
    font-size: 13px;
    margin: 6px 0 0;
    line-height: 1.4;
}
.sms-consent-shake {
    animation: smsConsentShake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
.sms-consent-shake .sms-consent-checkbox {
    animation: smsConsentPulse 0.6s ease both;
}
@keyframes smsConsentShake {
    10%, 90% { transform: translateX(-1px); }
    20%, 80% { transform: translateX(2px); }
    30%, 50%, 70% { transform: translateX(-4px); }
    40%, 60% { transform: translateX(4px); }
}
@keyframes smsConsentPulse {
    0%, 100% { transform: scale(1); }
    30% { transform: scale(1.3); }
    60% { transform: scale(0.95); }
}
</style>
